import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ProcessingButton from 'components/ProcessingButton';
import SimpleModal from 'components/SimpleModal';
import React, { FC, Fragment } from 'react';
import { Container } from 'reactstrap';
import EditorComponent from 'routes/tools/translationManager/EditorComponent';
import { cachedLanguages, useTranslationEditorContext } from 'utils/language';
import Translation from './Translation';
import { MdAutoAwesome } from 'react-icons/md';
import { get } from 'lodash';
import { useApi } from 'utils/API';
import { fetchLibreTranslate } from './utils';
import { choiceList } from 'utils/Prompts';
import { useConfig } from 'utils/Config';

const Modal = () => {
  const { languages, translationKey, setTranslationKey, updateLanguageKey } = useTranslationEditorContext();
  const mappings = useConfig().languageIsoCodeMapping
  const api = useApi()

  return (
    <SimpleModal
      open={translationKey !== null}
      title={<Translation name="T.misc.translationEditor" />}
      fullscreen
      onClose={() => setTranslationKey(null)}
      buttons={[
        <ProcessingButton
          color='info'
          onClick={async () => {
            const key = translationKey?.key
            const resolvedValue = get(cachedLanguages['English'], key, '');
            if (resolvedValue) {
              for (const language of languages) {
                if (language === 'English' || language === 'Descriptions') {
                  continue
                }

                const options = await fetchLibreTranslate(resolvedValue, mappings['English'], mappings[language])
                const newValue = await choiceList("Which one", [options.translatedText, ...options.alternatives].map(it => ({ label: it, value: it })))
                if (newValue) {
                  await api.language.updateLanguage({
                    language: language,
                    path: key,
                    value: newValue,
                  });
                  updateLanguageKey(language, key, newValue);
                }
              }
            }
          }}
        >
          <MdAutoAwesome />
        </ProcessingButton>,
        <ProcessingButton
          color="primary"
          onClick={() => setTranslationKey(null)}
          data-testid={'translation-editor-close'}
        >
          <FontAwesomeIcon icon={faCheckCircle} />
        </ProcessingButton>,
      ]}
    >
      <Container fluid>
        <b>
          <Translation name="T.misc.Identifier" />:
        </b>
        <br />
        {translationKey?.key}
        <br />
        <br />

        <b>
          <Translation name="T.misc.arguments" />:
        </b>
        <br />
        {translationKey?.args?.join?.(', ')}
        <br />
        <br />

        {languages.map((language) => {
          return (
            <Fragment key={language}>
              <br />
              <b>{language}:</b>
              <br />
              <EditorComponent language={language} row={translationKey?.key} />
            </Fragment>
          );
        })}
      </Container>
    </SimpleModal>
  );
};

const Wrapper: FC = ({ children }) => {
  return (
    <>
      <Modal />
      {children}
    </>
  );
};
export default Wrapper;
